// event_bus.js
// 親子関係にないコンポーネント間の通信を行うためのグローバスインスタンス
import mitt from 'mitt';

const emitter = mitt();
export const eventBus = {
    // mittが単一引数のみサポートしているため、可変長引数対応
    $on: (type, callback) => emitter.on(type, (args) => callback(...(Array.isArray(args) ? args : [args]))),
    $emit: (type, ...args) => emitter.emit(type, args)
};
